import { Modal, message } from 'antd'

const AccessPlugin = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')

  const code = `<script src="https://ai.yunzhaosoft.com/widget.js?client=${merchantOid}"></script>`

  const copyCode = () => {
    navigator.clipboard.writeText(code)
    message.success('代码已复制')
  }

  return (
    <Modal
      width={600}
      title="接入方式"
      open={props.isOpen}
      onCancel={props.isCancel}
      maskClosable={false}
      footer={null}
    >
      <div className='public-datail-container'>
        <div className='public-datail-label' style={{"width": "100%"}}>
          通过在网站中嵌入一行 {"<script>"}，即可在页面右下角显示 AI 客服入口。
        </div>
        <div className='public-datail-label' style={{"width": "100%"}}>
          点击下方按钮复制插件代码，然后将代码添加到网站 HTML 页面中，
          建议放在 {"</body>"} 标签之前并保存发布。
        </div>
        <div className='public-datail-label' style={{"width": "100%"}}>
          接入成功后，页面右下角会自动出现 AI 客服入口。
        </div>

        <div className='public-import-button2' style={{"width": "100px"}} onClick={copyCode}>
          <p>复制代码</p>
        </div>
      </div>
    </Modal>
  )
}

export default AccessPlugin